module.exports = __webpack_public_path__ + "img/zahajenie-vystavby.2e8d80a4.svg";